module.exports = "/lucky-balls/img/bonus_yellow/background.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/background.png
// module id = 943
// module chunks = 0